import { getAccessToken, getUID } from '@/common/utils/accountUtil';
import { useLanguageStore } from '$/store/languageStore';
import useTeamStore, { clearTeamInfo, setTeamInfo } from '@/store/useTeamStore';
import type { TeamListItem } from './types';
import { createTeam, getCurrentTeamInfo } from './teamService';

let ensureTeamInfoForPurchasePromise: Promise<TeamListItem | null> | null = null;

/**
 * 团队版购买前确保存在团队上下文；没有当前团队时创建默认团队并同步到 SDK 请求上下文。
 */
export async function ensureTeamInfoForPurchase(): Promise<TeamListItem | null> {
  const currentTeamInfo = useTeamStore.getState().teamInfo;
  if (currentTeamInfo?.client_ogroupid) {
    return currentTeamInfo;
  }

  const token = getAccessToken();
  const uid = getUID();
  if (!token || !uid) {
    clearTeamInfo();
    return null;
  }

  if (!ensureTeamInfoForPurchasePromise) {
    ensureTeamInfoForPurchasePromise = (async () => {
      const currentTeam = await getCurrentTeamInfo();
      if (currentTeam.identity === 'team' && currentTeam.team) {
        setTeamInfo(currentTeam.team);
        return currentTeam.team;
      }

      const createdTeam = await createTeam({
        name: useLanguageStore.getState().languageStore.smartcatTranslationText(
          (v) => v.untitled_team,
        ),
      });
      setTeamInfo(createdTeam);
      return createdTeam;
    })()
      .catch((error: unknown) => {
        console.error('ensureTeamInfoForPurchase error:', error);
        return null;
      })
      .finally(() => {
        ensureTeamInfoForPurchasePromise = null;
      });
  }

  return ensureTeamInfoForPurchasePromise;
}
